import classNames from "classnames";
import React from "react";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { useStore } from "../../store";

type SharkCounterProps = {
  className?: string;
};

const SharkCounterComponent: React.FC<SharkCounterProps> = ({ className }) => {
  const { t } = useTranslation();
  const { mainStore } = useStore();
  const rawCount = mainStore.currentSharkCount;
  const sharkCount = typeof rawCount === "number" && !Number.isNaN(rawCount) ? rawCount : 0;

  return (
    <div className={classNames("shark-counter", className)} aria-live="polite" aria-atomic="true">
      <div className="shark-counter-content">
        <p className="shark-counter-count">{t("counter.sharkCount", { count: sharkCount })}</p>
        <p className="shark-counter-text">
          {sharkCount === 1 ? t("counter.sharkAlreadyMade") : t("counter.sharksAlreadyMade")}
        </p>
      </div>
    </div>
  );
};

const SharkCounter = observer(SharkCounterComponent);

export default SharkCounter;
